import { FC } from 'react';
import { Skeleton } from 'antd';
import { AvatarTextSkeleton } from 'components/Shared/AvatarText/Skeleton';
import { NftMediaSkeleton } from 'components/Shared/NftMedia/Skeleton';
import * as Styled from './styles';
import type { TNftCardProps } from '../';

export const AllNftCardSkeleton: FC<Partial<TNftCardProps>> = ({
  size = 'medium',
  className,
  flexible = false
}) => {
  return (
    <Styled.NftCardWrapper
      $size={size}
      $flexible={flexible}
      className={className}
    >
      <Styled.NftCardMediaSkeleton>
        <NftMediaSkeleton />
      </Styled.NftCardMediaSkeleton>
      <Styled.NftCardAvatarTextWrapper>
        <AvatarTextSkeleton
          text=""
          size={size}
          shape="circle"
          fallbackInitials
        />
      </Styled.NftCardAvatarTextWrapper>
      <Styled.NftCardName>
        <Skeleton.Button
          block
          active
          style={{
            height: '16px',
            width: '70%',
            margin: '2 0'
          }}
        />
      </Styled.NftCardName>
      <Styled.NftCardPriceWrapper>&nbsp;</Styled.NftCardPriceWrapper>
    </Styled.NftCardWrapper>
  );
};
